import styled from "styled-components";
import { GenericSvg, SVGName } from "../../../assets/svgs/GenericSVG";
import { colors } from "../../styles/colors";
import { ButtonText } from "../../styles/stringStyles";
import { LoadingSpinner } from "../loading/LoadingSpinner";
import { CustomButton } from "./CustomButton";

export type MainButtonProps = {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  color?: string;
  className?: string;
  iconName?: SVGName;
};

export const MainButton = (props: MainButtonProps) => {
  return (
    <StyledCustomButton
      onClick={props.onClick}
      disabled={props.disabled}
      loading={props.loading}
      $color={props.color}
      className={props.className}
    >
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <StyledButtonText>{props.text}</StyledButtonText>
      )}
      {props.iconName && !props.loading && (
        <GenericSvg
          name={props.iconName}
          size={24}
          primaryColor={colors.white}
        />
      )}
    </StyledCustomButton>
  );
};

const StyledCustomButton = styled(CustomButton)<{ $color?: string }>`
  padding: 0 20px;
  border-radius: 100px;
  height: 50px;
  min-width: 200px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-color: ${({ theme, $color }) => $color || theme.colors.primary};
`;

const StyledButtonText = styled(ButtonText)`
  color: ${({ theme }) => theme.colors.white};
  position: relative;
  z-index: 1;
`;
